<template>
  <div class="section">
    <div class="container">
      <div class="level">
        <Header class="level-left" v-bind="$route.meta" />
        <b-button
          class="left-right"
          type="is-success"
          icon-left="plus"
          :disabled="selectedPlant === null"
          @click="showCreateForm()"
        >
          Create New Employee
        </b-button>
      </div>
      <div class="columns">
        <div class="column">
          <b-field grouped>
            <b-field v-if="hasGroupPlants" label="Plant">
              <b-select v-model="selectedPlant" icon="industry" expanded>
                <option v-for="plant in groupPlants" :key="plant.id" :value="plant">
                  {{ plant.name }}
                </option>
              </b-select>
            </b-field>
            <b-field v-else label="Plant">
              <multiselect
                v-model="selectedPlant"
                :options="plants"
                :multiple="false"
                :close-on-select="true"
                placeholder="Pick plant"
                :custom-label="(obj) => obj.id + ' - ' + obj.name"
                track-by="name"
                style="min-width: 400px;"
              />
            </b-field>
          </b-field>
          <b-field>
            <b-button
              class="left-right"
              type="is-warning"
              icon-left="arrows-rotate"
              :disabled="isLoading || selectedPlant === null"
              @click="() => {resetData(); getData();}"
            >
              Load
            </b-button>
          </b-field>
          <ag-grid-vue
            v-if="employees.length != 0"
            style="width: 100%; height: 700px;"
            class="ag-theme-balham"
            :row-data="employees"
            :grid-options="gridOptions"
            :pagination="true"
            :pagination-auto-page-size="true"
            :cache-overflow-size="0"
            :multi-sort-key="'ctrl'"
            :modules="modules"
            :get-context-menu-items="getContextMenuItems"
          />
        </div>
      </div>
    </div>
    <b-modal :active.sync="isCreatingEmployee" scroll="keep" has-modal-card>
      <form v-if="isCreatingEmployee" @submit.prevent="submitEmployee">
        <div class="modal-card" style="min-width: 50vw; width: fit-content; min-height: 50vh; height: fit-content;">
          <header class="modal-card-head">
            <p class="modal-card-title">
              Create Employee
              <span v-if="selectedPlant" style="font-size:1rem; text-overflow: elipsis">{{ selectedPlant.name }}</span>
            </p>
          </header>
          <section class="modal-card-body">
            <b-field grouped>
              <b-field label="First Name">
                <b-input v-model="newEmployee.name" type="text" placeholder="First Name" />
              </b-field>
              <b-field label="Last Name">
                <b-input v-model="newEmployee.surname" type="text" placeholder="Last Name" />
              </b-field>
            </b-field>
            <b-field grouped>
              <b-field label="Arrival Date">
                <b-input v-model="newEmployee.date_entree" type="date" />
              </b-field>
              <b-field label="Exit Date">
                <b-input v-model="newEmployee.date_sortie" type="date" />
              </b-field>
            </b-field>
            <b-field grouped>
              <b-field label="Employee Id">
                <b-input v-model="newEmployee.matricule" type="text" placeholder="Id" />
              </b-field>
              <b-button
                class="left-right"
                type="is-warning"
                style="margin-top: auto;"
                @click="() => {generateUserId()}"
              >
                Generate uuid
              </b-button>
            </b-field>
            <b-field label="Employee Title">
              <b-input v-model="newEmployee.title" type="text" />
            </b-field>
            <b-field label="Interim?">
              <b-switch
                v-model="newEmployee.interim"
              >
                {{ newEmployee.interim ? 'Yes' : 'No' }}
              </b-switch>
            </b-field>
          </section>
          <footer class="modal-card-foot">
            <button type="submit" class="button is-info is-fullwidth">
              {{ $t('global.submit') }}
            </button>
          </footer>
        </div>
      </form>
    </b-modal>
    <b-modal :active.sync="isEditingEmployee" scroll="keep" has-modal-card>
      <form v-if="isEditingEmployee" @submit.prevent="submitEdit">
        <div class="modal-card" style="min-width: 50vw; width: fit-content; min-height: 50vh; height: fit-content;">
          <header class="modal-card-head">
            <p class="modal-card-title">
              Edit Employee
              <span v-if="selectedPlant" style="font-size:1rem; text-overflow: elipsis">{{ selectedPlant.name }}</span>
            </p>
          </header>
          <section class="modal-card-body">
            <b-field grouped>
              <b-field label="First Name">
                <b-input v-model="editableEmployee.name" type="text" placeholder="Name" />
              </b-field>
              <b-field label="Last Name">
                <b-input v-model="editableEmployee.surname" type="text" placeholder="Surname" />
              </b-field>
            </b-field>
            <b-field grouped>
              <b-field label="Arrival Date">
                <b-input v-model="editableEmployee.date_entree" type="date" />
              </b-field>
              <b-field label="Exit Date">
                <b-input v-model="editableEmployee.date_sortie" type="date" />
              </b-field>
            </b-field>
            <!-- <b-field grouped>
              <b-field label="Employee Id">
                <b-input v-model="editableEmployee.matricule" type="text" placeholder="Id" />
              </b-field>
            </b-field> -->
            <b-field label="Employee Title">
              <b-input v-model="editableEmployee.title" type="text" />
            </b-field>
            <b-field label="Interim?">
              <b-switch
                v-model="editableEmployee.interim"
              >
                {{ editableEmployee.interim ? 'Yes' : 'No' }}
              </b-switch>
            </b-field>
          </section>
          <footer class="modal-card-foot">
            <button type="submit" class="button is-info is-fullwidth">
              {{ $t('global.submit') }}
            </button>
          </footer>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { AllModules } from '@ag-grid-enterprise/all-modules'
import { mapState } from 'vuex'
import EmployeeManagement from '../../services/v3/employeeManagement'
import { v4 as uuidv4 } from 'uuid'
import plantSelector from '@/mixins/plantSelector'
import { restoreConsultingPlant } from '@/helpers/plants'
// import sortAndFilterMixins from '@/mixins/agGridSortAndFilter'

export default {
  name: 'EmployeeManagement',
  components: {
  },
  mixins: [plantSelector],
  data: function () {
    return {
      editableEmployee: null,
      newEmployee: null,
      selectedPlant: restoreConsultingPlant(),
      isLoading: false,
      isCreatingEmployee: false,
      isEditingEmployee: false,
      employees: [],
      modules: AllModules,
      gridOptions: {
        cacheBlockSize: 20,
        paginationPageSize: 20,
        enableRangeSelection: true,
        defaultColDef: {
          floatingFilter: true,
          enableValue: true,
          enableRowGroup: true,
          enablePivot: false,
          resizable: true
        },
        columnDefs: [
          { headerName: 'Name',
            field: 'name',
            filter: 'agTextColumnFilter',
            width: 160,
            sortable: true,
            filterParams: { suppressAndOrCondition: true }
          },
          { headerName: 'Surname',
            field: 'surname',
            filter: 'agTextColumnFilter',
            width: 160,
            sortable: true,
            filterParams: { suppressAndOrCondition: true }
          },
          { headerName: 'Title',
            field: 'title',
            filter: 'agTextColumnFilter',
            width: 160,
            sortable: true,
            filterParams: { suppressAndOrCondition: true }
          },
          { headerName: 'Matricule',
            field: 'matricule',
            filter: 'agTextColumnFilter',
            width: 160,
            sortable: true,
            filterParams: { suppressAndOrCondition: true }
          },
          { headerName: 'Arrival Date',
            field: 'date_entree',
            filter: 'agTextColumnFilter',
            width: 160,
            sortable: true,
            filterParams: { suppressAndOrCondition: true }
          },
          { headerName: 'Exit Date',
            field: 'date_sortie',
            filter: 'agTextColumnFilter',
            width: 160,
            sortable: true,
            filterParams: { suppressAndOrCondition: true }
          },
          { headerName: 'Interim',
            field: 'interim',
            filter: 'agTextColumnFilter',
            width: 160,
            sortable: true,
            filterParams: { suppressAndOrCondition: true },
            valueFormatter: (params) => {
              return params.value ? 'Yes' : 'No'
            }
          }
        ],
        sideBar: {
          toolPanels: [
            {
              id: 'columns',
              labelDefault: 'Columns',
              labelKey: 'columns',
              iconKey: 'columns',
              toolPanel: 'agColumnsToolPanel',
              toolPanelParams: {
                // tool panel columns won't move when columns are reordered in the grid
                suppressSyncLayoutWithGrid: true,
                // prevents columns being reordered from the Columns Tool Panel
                suppressColumnMove: true
              }
            }
          ],
          defaultToolPanel: ''
        }
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  mounted: async function () {
    await this.loadPlants()
  },
  methods: {
    resetData () {
      this.employees = []
    },
    showCreateForm () {
      this.isCreatingEmployee = true
      this.newEmployee = {
        name: null,
        surname: null,
        matricule: uuidv4(),
        date_entree: null,
        date_sortie: null,
        interim: false,
        title: null,
        siteId: this.selectedPlant.id
      }
    },
    generateUserId () {
      this.newEmployee.matricule = uuidv4()
    },
    showEditForm (employee) {
      this.isEditingEmployee = true
      this.editableEmployee = employee
    },
    async getData () {
      if (!this.selectedPlant || !this.selectedPlant.id) {
        this.$buefy.toast.open({ message: 'Please select a plant', duration: 3000, type: 'is-danger' })
        return
      }
      sessionStorage.setItem('consultingPlant', JSON.stringify(this.selectedPlant))
      this.isLoading = true
      try {
        const data = await EmployeeManagement.getTable({
          siteId: this.selectedPlant.id
        })
        data.forEach(element => {
          this.employees.push({
            id: element.id,
            id_site: element.id_site,
            name: element.name,
            matricule: element.matricule,
            title: element.title,
            surname: element.surname,
            interim: element.interim,
            date_entree: element.date_entree ? new Date(element.date_entree.split('Z')[0]).toLocaleDateString('en-CA') : null,
            date_sortie: element.date_sortie ? new Date(element.date_sortie.split('Z')[0]).toLocaleDateString('en-CA') : null
          })
        })
        if (this.employees.length > 0) {
          this.$buefy.toast.open({ message: 'Data loaded', duration: 3000, type: 'is-success' })
        } else {
          this.$buefy.toast.open({ message: 'No corresponding employees found', duration: 3000, type: 'is-danger' })
        }
      } catch (error) {
        this.$buefy.toast.open({ message: error.message, duration: 3000, type: 'is-danger' })
        this.isLoading = false
      }
      this.isLoading = false
    },
    getContextMenuItems (params) {
      const selectedEmployee = params.node.data
      let customMenu = []
      const genericMenu = [
        'separator',
        'copy',
        'copyWithHeaders',
        'separator',
        'export'
      ]
      customMenu.push({
        name: 'Edit Employee',
        action: () => {
          this.showEditForm(selectedEmployee)
        },
        icon: '<i class="fas fa-fw fa-edit" ></i>'
      })
      customMenu.push({
        name: 'Delete Employee',
        action: () => {
          this.deleteEmployee(selectedEmployee)
        },
        icon: '<i class="fas fa-fw fa-xmark" ></i>'
      })
      const result = [...customMenu, ...genericMenu]
      return result
    },
    submitEmployee () {
      this.isCreatingEmployee = false
      try {
        EmployeeManagement.createEmployee(this.newEmployee).then(() => {
          this.$buefy.toast.open({ message: 'Employee Created', duration: 3000, type: 'is-success' })
          this.resetData()
          this.getData()
        })
      } catch (error) {
        this.$buefy.toast.open({ message: error.message, duration: 3000, type: 'is-danger' })
      }
    },
    async submitEdit () {
      this.isEditingEmployee = false
      try {
        await EmployeeManagement.updateEmployee(this.editableEmployee)
        this.$buefy.toast.open({ message: 'Employee Updated', duration: 3000, type: 'is-success' })
        this.resetData()
        this.getData()
      } catch (error) {
        this.$buefy.toast.open({ message: error.message, duration: 3000, type: 'is-danger' })
      }
    },
    async deleteEmployee (employee) {
      try {
        await EmployeeManagement.archiveEmployee(employee.id)
        this.$buefy.toast.open({ message: 'Employee Deleted', duration: 3000, type: 'is-warning' })
        this.resetData()
        this.getData()
      } catch (error) {
        this.$buefy.toast.open({ message: error.message, duration: 3000, type: 'is-danger' })
      }
    }
  }
}

</script>
